import './Historia.css';

export default function Historia() {
  const WA = 'https://wa.me/573106800438?text=Hola!%20Quiero%20hacer%20un%20pedido%20a%20domicilio%20';

  return (
    <section className="hist" id="historia">
      <div className="hist__img-col">
        {/* Imagen Principal */}
        <div className="hist__img-main">
          <img src="/images/historia-pizza.jpg" alt="Pizzería La Viña" />
        </div>
        
        {/* Imagen Secundaria */}
        <div className="hist__img-sec">
          <img src="/images/logo-pizza.png" alt="Pizza artesanal" />
        </div>

        <div className="hist__years">
          <span className="hist__years-num">30+</span>
          <span className="hist__years-label">Años de<br />tradición</span>
        </div>
      </div>

      <div className="hist__content">
        <span className="tag">— Nuestra historia</span>
        <h2 className="section-title">
          Tradición que llega<br />
          hasta tu <em>puerta</em>
        </h2>
        <div className="divider-italy"><span/><span/><span/></div>
        
        <p className="section-sub">
          Pizzería La Viña es un <strong>emblema de Barranquilla</strong> que nació en los 90. Durante décadas crecimos junto a nuestra comunidad en la Cra 14, creando recuerdos inolvidables.
        </p>
        
        {/* MENSAJE CLAVE: SOLO DOMICILIOS */}
        <div className="hist__delivery-notice">
          <p className="section-sub">
            Hoy evolucionamos para seguir brindándote el sabor de siempre. 
            <strong> Atendemos exclusivamente a través de domicilios</strong>, manteniendo la receta original y la calidad artesanal que nos hizo grandes.
          </p>
          <a href={WA} target="_blank" rel="noreferrer" className="btn-red">
            Pide tu domicilio aquí
          </a>
        </div>

        <div className="hist__pillars">
          {[
            { icon:'/images/masa-artesanal.jpeg', t:'Masa artesanal',     d:'Nuestra receta secreta preparada a diario.' },
            { icon:'/images/ingredientes-frescos.jpg', t:'Calidad Premium',  d:'Los mismos ingredientes seleccionados de hace 30 años.' },
            { icon:'/images/domicilio.jpg', t:'Envíos Seguros',    d:'Despachos rápidos y calientes a toda Barranquilla.' },
          ].map(p => (
            <div className="hist__pillar" key={p.t}>
              <img src={p.icon} alt={p.t} className="hist__pillar-img-icon" />
              <div>
                <div className="hist__pillar-title">{p.t}</div>
                <div className="hist__pillar-desc">{p.d}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
